export enum TabsEnum{
  CUISSON,
  EQUIPEMENTS_DOMESTIQUE,
  ECLAIRAGE,
  SALLE_D_EAU,
  ENERGIE,
}
